import React, { Component } from "react";
import { t, setLocale } from "../../helpers/translate";
import { setMicrositeColour } from "../../helpers/style";
import ModalComponent from "../common/ModalComponent";

import linkIcon from "../../Logos/MemberPortal/link-icon.svg";

import mshENLogo from "../../Logos/MSH-Square_EN.png";
import mshFRLogo from "../../Logos/MSH-Square_FR.png";
import FloatToTopButton from "../common/FloatToTopButton";
import AnnouncementFR from "./AnnouncementFR";
import AnnouncementEN from "./AnnouncementEN";
import PostalDisruption from "./PostalDisruption";
import ReactGA from "react-ga4";
import Icon from "react-fa";
let config = require("config");

class MemberPortal extends Component {
  constructor(props) {
    setLocale(props.params.lang);
    setMicrositeColour(props.params.microsite);

    sessionStorage.setItem("hide_navbar", true);
    document.body.style.backgroundColor = "white";
    super(props);

    this.state = {
      policyNumber: "",
      hasError: false,
      errorMessage: null,
      showWalletCard: false,
      showPSHCPUpdateModal: false,
      showPostalDisruptionModal: false,
      lang: props.params.lang,
    };

    const measurementIds = config.default.MEMBER_PORTAL_LANDING_PAGE_GA_measurement_id;

    const GA_ID = props.params.lang === 'en' ? measurementIds.pshcp : measurementIds.rssfp;

    ReactGA.initialize(GA_ID);

    this.fireEvent("member_portal_landing_page");
  }

  fireEvent(action, category = "member_portal") {

    const { microsite, lang } = this.props.params;
    const { policyNumber } = this.state;

    const eventObject = {
      hitType: "event",
      eventCategory: category,
      eventAction: action,
      eventLabel: microsite,
      school_name: microsite,
      locale: lang,
    };

    ReactGA.send(eventObject);
  }

  renderModal() {
    const { showPSHCPUpdateModal, lang} = this.state;

    if (showPSHCPUpdateModal) {
      return lang === "en" ? <AnnouncementEN /> : <AnnouncementFR />;
    }

    if(this.state.showPostalDisruptionModal) {
      return <PostalDisruption lang={this.state.lang} />;
    }
  }

  renderTitle() {
    if (this.state.showPSHCPUpdateModal) {
      return t("Update from MSH International to PSHCP members");
    }

    if (this.state.showPostalDisruptionModal) {
      return t("Potential national postal disruption");
    }
  }

  renderFaqLink = (url, label, GA_EVENT) => (
    <a
      href="#"
      onClick={() => {
        this.fireEvent(GA_EVENT);
        window.open(url, "_blank");
      }}
      className="link"
    >
      {t(label)}
      <img src={linkIcon} className="link-icon" />
    </a>
  );

  render() {
    const { lang } = this.state;
    const newLang = lang === "en" ? "fr" : "en";

    const links = {
      compClaimForm: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Comprehensive_claims_incurred_outside_of_Canada_claimform.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Demande_de_reglement_pour_frais_engages_a_lexterieur_du_Canada_au_titre_de_la_protection_totale.pdf",
      },
      suppClaimForm: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Emergency_benefit_while_travelling_claimform.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Demande_de_reglement_au_titre_de_la_garantie-voyage_durgence.pdf",
      },
      faq: {
        en: "https://www.welcome.canadalife.com/pshcp/msh/msh-member-update.html",
        fr: "https://www.bienvenue.canadavie.com/rssfp/msh/msh-mise-a-jour.html",
      },
      privacy: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Privacy_Disclaimer.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Protection_des_renseignements_personnels.pdf",
      },
      PSHCPMemberServiceWebsite: {
        en: "https://www.welcome.canadalife.com/pshcp",
        fr: "https://www.bienvenue.canadavie.com/rssfp",
      },
      publicServiceHealthCarePlan: {
        en: "https://www.pshcp.ca/",
        fr: "https://www.rssfp.ca/",
      },
      membersWithSuppCoverage: {
        en: "https://www.pshcp-msh.ca/a/eta",
        fr: "https://www.rssfp-msh.ca/a/eta",
      },
      membersWithCompCoverage: {
        en: "https://www.pshcp-msh.ca/a/comp",
        fr: "https://www.rssfp-msh.ca/a/comp",
      },
      leavingCanada: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Deployment_Leaving_Canada.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Vous_quittez_le_Canada.pdf",
      },
      returnToCanada: {
        en: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Deployment_Returning_to_Canada.pdf",
        fr: "http://docs.mshtravel.com/docs/Travel/MapleLeaf/Deploiement_Vous_revenez_au_Canada.pdf",
      }
    };

    const showModal = this.state.showPSHCPUpdateModal || this.state.showPostalDisruptionModal;

    return (
      <div className="member-portal">
        <a className="skip-to-content" href="#main-id">
          Skip to content
        </a>
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container">
              <div className="navbar-brand">
                <img
                  src={lang == "en" ? mshENLogo : mshFRLogo}
                  width="60"
                  height="60"
                  alt="MSH Canada"
                />
              </div>
              <span
                className="row-flex navbar-lang"
                onClick={() => {
                  const member_portal_url_en = "https://pshcp-msh.ca";
                  const member_portal_url_fr = "https://rssfp-msh.ca";

                  if (location.hostname !== "dashboard.studyinsured.com") {
                    location.replace(`/msh/member_portal/${newLang}`);
                  } else {
                    parent.location.href = eval(
                      `member_portal_url_${newLang}`
                    );
                  }
                }}
              >
                {newLang.toUpperCase()}
              </span>
            </div>
          </nav>
        </div>

        <div className="info-banner">
          {t("Potential national postal disruption: In the event of a national postal disruption, MSH is ready to help ensure continued service for members.")}

          <a href="#" className="link" onClick={() => {
            this.fireEvent("national_postal_disruption_notice");
            this.setState({ showPostalDisruptionModal: true });
          }}>
            {t("Learn how.")}
            <Icon name="external-link" id="icon"/>
          </a>
        </div>

        <div className="main-wrapper">
          <div className="container">
            <div className="row text-center">
              <h1 className="mp-h1">
                {t("Welcome to the MSH Public Service Health Care Plan (PSHCP) Member Portal")}
              </h1>
              <h2 className="mp-h2">
                {t("MSH International (MSH) is your emergency travel assistance and Comprehensive Coverage provider for the Public Service Health Care Plan (PSHCP).")}
              </h2>
            </div>
          </div>
        </div>

        <div className="container mp-box">
          <h2>{t("Log in or register for your account")}</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="mp-box-header">
                <h2 className="mp-box-title">
                  {t("Members with Supplementary Coverage")}
                </h2>
              </div>
              <div className="mp-box-body">
                <p className="mp-box-descprition">
                  ({t("Incurring emergency expenses while travelling")}):
                </p>
                <button
                  className="btn button-secondary mp-button"
                  tabIndex="0"
                  onClick={() => {
                    this.fireEvent("login_or_register_members_with_supp_coverage");
                    window.open(links.membersWithSuppCoverage[lang], "_blank");
                  }}
                >
                  <span className="row-flex">
                    {t("Log in or register")}
                    <div className="mp-arrow" />
                  </span>
                </button>
              </div>
            </div>
            <div className="vertical" />
            <div className="col-md-6">
              <div className="mp-box-header">
                <h2 className="mp-box-title">
                  {t("Members with Comprehensive Coverage")}
                </h2>
              </div>

              <div className="mp-box-body" id="main-id">
                <p className="mp-box-descprition">
                  (
                  {t(
                    "incurring expenses outside of Canada while posted, deployed, or living abroad"
                  )}
                  ):
                </p>
                <button
                  className="btn button-secondary mp-button"
                  onClick={() => {
                    this.fireEvent("login_or_register_members_with_comp_coverage");
                    window.open(links.membersWithCompCoverage[lang], "_blank");
                  }}
                >
                  <span className="row-flex">
                    {t("Log in or register")}
                    <div className="mp-arrow" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="center-children" style={{ padding: "0 30px" }}>
          <button
            className="btn button-secondary mp-button update-button"
            onClick={() => {
              this.setState({ showPSHCPUpdateModal: true });
              this.fireEvent("PSHCP_members_update");
            }}
          >
            {t("Update from MSH International to PSHCP members")}
          </button>
        </div>

        <div className="claims-info">
          <h2 className="title">{t("MSH processes the following claims")}: </h2>
          <ul>
            <li>
              {t(
                "Emergency Travel Assistance (ETA) claims for members with Supplementary Coverage"
              )}
            </li>
            <li>
              {t(
                "Claims for expenses incurred outside of Canada for members with Comprehensive Coverage"
              )}
            </li>
          </ul>

          <p>
            {t("All other claims should be submitted to")}
            <a
              href="#"
              onClick={() => {
                this.fireEvent("claims_canada_life");
                window.open(links.PSHCPMemberServiceWebsite[lang], "_blank");
              }}
              className="link"
            >
              {t("Canada Life")}
              <img src={linkIcon} className="link-icon-img" />.
            </a>
          </p>
        </div>

        <div className="claims-form">
          <h2>{t("Claim Forms")}</h2>
          <div>
            {t("Supplementary Coverage")}:
            <a
              href="#"
              onClick={() => {
                this.fireEvent("claims_form_supplementary");
                window.open(links.suppClaimForm[lang], "_blank");
              }}
              className="link"
            >
              <span className="link-text">
                {t("Emergency Benefit While Travelling Claim Form")}
                <img src={linkIcon} className="link-icon-img" />
              </span>
            </a>
          </div>

          <div>
            {t("Comprehensive Coverage")}:
            <a
              href="#"
              onClick={() => {
                this.fireEvent("claims_form_comprehensive");
                window.open(links.compClaimForm[lang], "_blank");
              }}
              className="link"
            >
              <span className="link-text">
                {t(
                  "Comprehensive Claims Incurred Outside of Canada Claim Form"
                )}
                <img src={linkIcon} className="link-icon-img" />
              </span>
            </a>
          </div>
        </div>

        <hr />

        <div className="contact center-children">
          <div className="row contact-flex">
            <div className="col-md-7 flex-column">
              <h2 className="title">{t("Contact us")}</h2>
              <div className="box flex-grow">
                <div className="row">
                  <div className="col-md-6">
                    <h3 className="box-title">
                      <div className="phone-logo" />
                      {t("Phone")}
                    </h3>

                    <div className="box-content">
                      <div className="box-subtitle">
                        {t("NORTH AMERICA (Toll-free):")}
                      </div>
                      <div className="number">
                        <span>1-833-774-2700
                          {lang === "en" && <span> (24/7)</span>}
                          {lang === "fr" && <span> (24 h/7 j)</span>}
                        </span>
                        {lang === "en" && <span>(1-833-PSHCP-00)</span>}
                      </div>

                      <div className="box-subtitle">
                        {t("INTERNATIONAL (COLLECT):")}
                      </div>
                      <div className="number">
                        <span>1-365-337-7427
                          {lang === "en" && <span> (24/7)</span>}
                          {lang === "fr" && <span> (24 h/7 j)</span>}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="box-divider" />

                  <div className="col-md-6">
                    <h3 className="box-title">
                      <div className="mail-logo" />
                      {t("Claims address")}
                    </h3>

                    <div className="box-content">
                      <div className="address-text">
                        <span>MSH International</span>
                        <span>{t("PO Box 4903, Stn A")}</span>
                        <span>Toronto, ON, M5W 0B1</span>
                        <span>Canada</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-5 flex-column">
              <h2 className="title">{t("Key Information")}</h2>
              <div className="box flex-grow">
                <div className="box-content">
                  {this.renderFaqLink(links.faq[lang], "FAQ and Cryptocurrency update", "key_information_faq")}
                  {this.renderFaqLink(links.PSHCPMemberServiceWebsite[lang], "PSHCP Member Services website", "key_information_PSHCP_member_services")}
                  {this.renderFaqLink(links.publicServiceHealthCarePlan[lang], "PSHCP Administration Authority", "key_information_PSHCP_administration_authority")}
                  {this.renderFaqLink(links.leavingCanada[lang], "Deployment: Leaving Canada?", "key_information_leaving_canada")}
                  {this.renderFaqLink(links.returnToCanada[lang], "Deployment: Returning to Canada?", "key_information_return_to_canada")}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer">
          <div className="left">
            <p>© MSH International (Canada) Ltd., 2023</p>
          </div>

          <div className="right">
            <a
              href={links.privacy[lang]}
              target='_blank'
            >
              {t("Privacy")}
              <div className="link-icon" />
            </a>
            <a
              href={links.faq[lang]}
              target='_blank'
            >
              {t("FAQ and Cryptocurrency update")}
              <div className="link-icon" />
            </a>
          </div>
        </div>
        <ModalComponent
          title={this.renderTitle()}
          body={this.renderModal()}
          onClose={this.setState.bind(this, { showPSHCPUpdateModal: false, showPostalDisruptionModal: false })}
          show={showModal}
          resetDataOnClose={false}
          size="large"
        />
        <FloatToTopButton />
      </div>
    );
  }
}

MemberPortal.displayName = "Member Portal";
export default MemberPortal;



// WEBPACK FOOTER //
// ./src/components/MemberPortal/MemberPortal.js